import axios from 'axios'
import store from '@/store/index.js';

class HttpRequest {
    constructor(url = process.env.VUE_APP_API_URL) {
        this.axiosInstance = axios.create({
            baseURL: url,
            timeout: 60000,
            withCredentials: true,
        })

        this.axiosInstance.interceptors.request.use(async function (config) {
            // Do something before request is sent
            const token = await store.dispatch('keycloak/getToken') || localStorage.getItem('token');
            if (token) return { ...config, headers: { 'Authorization': 'Bearer ' + token } };

            return config
        }, function (error) {
            // Do something with request error
            return Promise.reject(error)
        })

        // Add a response interceptor
        this.axiosInstance.interceptors.response.use(function (response) {
            // Do something with response data
            return response
        }, function (error) {
            // Do something with response error
            return Promise.reject(error)
        })
    }

    setHeader(header) {
        this.axiosInstance.defaults.headers.common[header.key] = header.value
        this.axiosInstance.defaults.headers.common = header
        this.axiosInstance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
    }

    get(methodName, data, config) {
        return this.axiosInstance.get(methodName, { params: data, ...config })
    }

    create(methodName, data, config) {
        return this.axiosInstance.post(methodName, data, config)
    }

    post(methodName, data, config) {
        return this.axiosInstance.post(methodName, data, config)
    }

    update(methodName, data, config) {
        return this.axiosInstance.put(methodName, data, config)
    }

    delete(methodName, param, data, config) {
        return this.axiosInstance.delete(methodName, { params: param, data: data, ...config })
    }

    request(type, url, data, config) {
        let promise = null
        switch (type) {
            case 'GET': promise = axios.get(url, { params: data, ...config }); break
            case 'POST': promise = axios.post(url, data, config); break
            case 'PUT': promise = axios.put(url, data, config); break
            case 'DELETE': promise = axios.delete(url, data, config); break
            default: promise = axios.get(url, { params: data, ...config }); break
        }
        return promise
    }
}

export default HttpRequest